{
  "v": "4.8.0",
  "meta": { "g": "LottieFiles AE 2.0.4", "a": "", "k": "", "d": "", "tc": "" },
  "fr": 24,
  "ip": 0,
  "op": 44,
  "w": 24,
  "h": 24,
  "nm": "loadingspinner_export 3",
  "ddd": 0,
  "assets": [
    {
      "id": "comp_0",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 3,
          "nm": "comet1_cntrl 4",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                { "i": { "x": [0.338], "y": [0.527] }, "o": { "x": [0.739], "y": [0] }, "t": 6, "s": [0.609] },
                { "i": { "x": [0.434], "y": [1] }, "o": { "x": [0.591], "y": [0.381] }, "t": 28, "s": [175.084] },
                { "t": 50, "s": [358.134] }
              ],
              "ix": 10
            },
            "p": { "a": 0, "k": [129.957, 132.021, 0], "ix": 2 },
            "a": { "a": 0, "k": [52, 54, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 0,
          "op": 49,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 3,
          "nm": "comet1_cntrl 3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                { "i": { "x": [0.338], "y": [0.527] }, "o": { "x": [0.739], "y": [0] }, "t": 4, "s": [0.609] },
                { "i": { "x": [0.434], "y": [1] }, "o": { "x": [0.591], "y": [0.381] }, "t": 26, "s": [175.084] },
                { "t": 48, "s": [358.134] }
              ],
              "ix": 10
            },
            "p": { "a": 0, "k": [129.957, 132.021, 0], "ix": 2 },
            "a": { "a": 0, "k": [52, 54, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 0,
          "op": 49,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 3,
          "nm": "comet1_cntrl 2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                { "i": { "x": [0.338], "y": [0.527] }, "o": { "x": [0.739], "y": [0] }, "t": 2, "s": [0.609] },
                { "i": { "x": [0.434], "y": [1] }, "o": { "x": [0.591], "y": [0.381] }, "t": 24, "s": [175.084] },
                { "t": 46, "s": [358.134] }
              ],
              "ix": 10
            },
            "p": { "a": 0, "k": [129.957, 132.021, 0], "ix": 2 },
            "a": { "a": 0, "k": [52, 54, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 0,
          "op": 49,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 3,
          "nm": "comet1_cntrl",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                { "i": { "x": [0.338], "y": [0.527] }, "o": { "x": [0.739], "y": [0] }, "t": 0, "s": [0.609] },
                { "i": { "x": [0.434], "y": [1] }, "o": { "x": [0.591], "y": [0.381] }, "t": 22, "s": [175.084] },
                { "t": 44, "s": [358.134] }
              ],
              "ix": 10
            },
            "p": { "a": 0, "k": [129.957, 132.021, 0], "ix": 2 },
            "a": { "a": 0, "k": [52, 54, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 0,
          "op": 49,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "comet4",
          "parent": 1,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 40, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [152.052, 52.876, 0], "ix": 2 },
            "a": { "a": 0, "k": [99.048, 3.948, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.479, 0.479, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.26, 0.26, 0.333], "y": [0.293, 0.293, 0] },
                  "t": -0.169,
                  "s": [55.643, 55.643, 100]
                },
                {
                  "i": { "x": [0.314, 0.314, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.724, 0.724, 0.333], "y": [0, 0, 0] },
                  "t": 14,
                  "s": [100, 100, 100]
                },
                {
                  "i": { "x": [0.446, 0.446, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.464, 0.464, 0.333], "y": [0, 0, 0] },
                  "t": 21.831,
                  "s": [55.643, 55.643, 100]
                },
                {
                  "i": { "x": [0.848, 0.848, 0.667], "y": [0.819, 0.819, 1] },
                  "o": { "x": [0.595, 0.595, 0.333], "y": [0, 0, 0] },
                  "t": 33,
                  "s": [100, 100, 100]
                },
                { "t": 43.8310546875, "s": [55.643, 55.643, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [37.859, 37.859], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.5215686274509804, 0.6, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [98.656, 3.254], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 49,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "comet3",
          "parent": 2,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 60, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [152.052, 52.876, 0], "ix": 2 },
            "a": { "a": 0, "k": [99.048, 3.948, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.479, 0.479, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.26, 0.26, 0.333], "y": [0.293, 0.293, 0] },
                  "t": -0.169,
                  "s": [55.643, 55.643, 100]
                },
                {
                  "i": { "x": [0.314, 0.314, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.724, 0.724, 0.333], "y": [0, 0, 0] },
                  "t": 14,
                  "s": [100, 100, 100]
                },
                {
                  "i": { "x": [0.446, 0.446, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.464, 0.464, 0.333], "y": [0, 0, 0] },
                  "t": 21.831,
                  "s": [55.643, 55.643, 100]
                },
                {
                  "i": { "x": [0.848, 0.848, 0.667], "y": [0.819, 0.819, 1] },
                  "o": { "x": [0.595, 0.595, 0.333], "y": [0, 0, 0] },
                  "t": 33,
                  "s": [100, 100, 100]
                },
                { "t": 43.8310546875, "s": [55.643, 55.643, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [37.859, 37.859], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.5215686274509804, 0.6, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [98.656, 3.254], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 49,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "comet2",
          "parent": 3,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 80, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [152.052, 52.876, 0], "ix": 2 },
            "a": { "a": 0, "k": [99.048, 3.948, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.479, 0.479, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.26, 0.26, 0.333], "y": [0.293, 0.293, 0] },
                  "t": -0.169,
                  "s": [55.643, 55.643, 100]
                },
                {
                  "i": { "x": [0.314, 0.314, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.724, 0.724, 0.333], "y": [0, 0, 0] },
                  "t": 14,
                  "s": [100, 100, 100]
                },
                {
                  "i": { "x": [0.446, 0.446, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.464, 0.464, 0.333], "y": [0, 0, 0] },
                  "t": 21.831,
                  "s": [55.643, 55.643, 100]
                },
                {
                  "i": { "x": [0.848, 0.848, 0.667], "y": [0.819, 0.819, 1] },
                  "o": { "x": [0.595, 0.595, 0.333], "y": [0, 0, 0] },
                  "t": 33,
                  "s": [100, 100, 100]
                },
                { "t": 43.8310546875, "s": [55.643, 55.643, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [37.859, 37.859], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.5215686274509804, 0.6, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [98.656, 3.254], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 49,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "comet1",
          "parent": 4,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [152.052, 52.876, 0], "ix": 2 },
            "a": { "a": 0, "k": [99.048, 3.948, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.479, 0.479, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.26, 0.26, 0.333], "y": [0.293, 0.293, 0] },
                  "t": -0.169,
                  "s": [55.643, 55.643, 100]
                },
                {
                  "i": { "x": [0.314, 0.314, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.724, 0.724, 0.333], "y": [0, 0, 0] },
                  "t": 14,
                  "s": [100, 100, 100]
                },
                {
                  "i": { "x": [0.446, 0.446, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.464, 0.464, 0.333], "y": [0, 0, 0] },
                  "t": 21.831,
                  "s": [55.643, 55.643, 100]
                },
                {
                  "i": { "x": [0.848, 0.848, 0.667], "y": [0.819, 0.819, 1] },
                  "o": { "x": [0.595, 0.595, 0.333], "y": [0, 0, 0] },
                  "t": 33,
                  "s": [100, 100, 100]
                },
                { "t": 43.8310546875, "s": [55.643, 55.643, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [37.859, 37.859], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.5215686274509804, 0.6, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [98.656, 3.254], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 49,
          "st": 0,
          "bm": 0
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 0,
      "nm": "Comp 6",
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [12, 12, 0], "ix": 2 },
        "a": { "a": 0, "k": [128, 128, 0], "ix": 1 },
        "s": { "a": 0, "k": [7, 7, 100], "ix": 6 }
      },
      "ao": 0,
      "w": 256,
      "h": 256,
      "ip": 0,
      "op": 48,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
